import { useEffect, useState } from "react";
import { Logo } from "../Logo";
import { CONTACT } from "../../lib/data";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Briefs", href: "#briefs" },
  { label: "Process", href: "#process" },
  { label: "Timeline", href: "#timeline" },
  { label: "Explore", href: "#gateways" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,padding] duration-500 ${
        scrolled
          ? "bg-[#0a0a0a]/85 backdrop-blur-xl border-b border-white/10 py-3"
          : "bg-transparent border-b border-transparent py-5"
      }`}
    >
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8 flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-xs uppercase tracking-[0.2em] font-bold text-neutral-300 hover:text-[#e62429] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="#contact"
          data-testid="nav-contact-cta"
          className="group relative inline-flex items-center gap-2 bg-[#e62429] px-5 py-2.5 text-xs font-bold uppercase tracking-[0.18em] text-white hover:bg-white hover:text-black transition-colors duration-300"
        >
          Get in touch
        </a>
      </div>
    </header>
  );
};
